import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token from localStorage as a fallback (used by extension flow)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("clyde_session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { API };
